import {
  DOCUMENT,
  inject,
  InjectionToken,
  RendererFactory2,
} from '@angular/core';

import type { Renderer2 } from '@angular/core';

const LOCAL_STORAGE = new InjectionToken<Storage>(
  'An abstraction over window.localStorage object',
  {
    factory: (): Storage => inject(WINDOW).localStorage,
  },
);

const WINDOW = new InjectionToken<Window>(
  'An abstraction over global window object',
  {
    factory: (): Window => {
      const { defaultView } = inject(DOCUMENT);

      if (!defaultView) {
        throw new Error('Window is not available');
      }

      return defaultView;
    },
  },
);

const BROWSER = new InjectionToken<string>('UserAgent string', {
  factory: (): string =>
    (navigator as Navigator | undefined) ? navigator.userAgent : '',
});

const VERSION = new InjectionToken<string>('VERSION');

const DEFAULT_RENDERER = new InjectionToken<Renderer2>(
  'A Renderer2 for global services',
  {
    factory: (): Renderer2 =>
      inject(RendererFactory2).createRenderer(null, null),
  },
);

export { BROWSER, DEFAULT_RENDERER, LOCAL_STORAGE, VERSION, WINDOW };
